import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { withSidebar } from "../hoc/withSidebar";
import { useTranslation } from "react-i18next";
import ERPSBaseButton from "../custom/inputs/ERPSBaseButton";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import ERPSTransactionDetails from "../custom/ERPSTransactionDetails";
import actions from "../../actions";
import ConfirmationMessage from "../custom/containers/ConfirmationMesssage";
import ErrorMessage from "../custom/containers/ErrorMessage";
import DialogHeader from "../custom/inputs/ERPSBaseModelDialog";
import { checkFieldValue, checkLengthAndRegex } from "../../utils/helper";
import { Regex } from "../../constants/sharedConstants.js";
import { Dialog, DialogActions, DialogContent, HStack, ResponsiveBox, Stack, TextField, Typography } from "../primitives";



const TraceInitationDetails = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    location: { state },
  } = props;


  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state for close button
  const [comment, setComment] = useState(""); // Input for comment
  const [commentError, setCommentError] = useState(""); // Validation error message
  const [isTraceInitiated, setIsTraceInitiated] = useState(false);

  const traceData = useSelector(
    (state) => state.tracePaymentReducer?.tracePaymentData?.data
  );
  const successMessage = useSelector(
    (state) => state.tracePaymentReducer?.initiateTraceSuccessMessage
  );

  const errorMessage = useSelector(
    (state) => state.tracePaymentReducer?.initiateTraceErrorMessage
  );


  const user = useSelector((state) => state.loginUserReducer.user);

  const errorRef = useRef();
  const successRef = useRef();
  const printComponentRef = useRef();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleCommentChange = (e) => {
    const value = e.target.value;
    let errMsg = checkLengthAndRegex(value, "erps.tracepayment.label.trace.reason", 300, Regex.regularText);
    // one invalid character will show in the field, but further input isn't allowed until the invalid character is removed
    setCommentError(errMsg);
    if ("" === errMsg || Regex.regularText.test(comment)) // if either current value is valid or previous value is valid
      setComment(value);
  };

  useEffect(() => {
    if (successRef.current) {
      successRef.current.focus();
    }
  }, [successMessage && showSuccessMessage]);


  useEffect(() => {
    if (errorRef.current) {
      errorRef.current.focus();
    }
  }, [errorMessage?.length]);

  useEffect(() => {
    dispatch({ type: "INITIATE_TRACE_SUCCESS", data: null })

    return onExit;
  }, []);

  const onExit = () => {
    errorRef.current = null;
    successRef.current = null;
    printComponentRef.current = null;
  }

  let data = traceData
    ? traceData.find(({ id }) => id === state.id)
    : {};
  if (!data.id)
    console.log("! ! ! ! ! !  data HAS NO ID ! ! ! ! !");

  const handleInitiateTrace = () => {
    let errorMsg = checkFieldValue(comment, "erps.tracepayment.label.trace.reason", true, (v) => Regex.regularText.test(v));
    setCommentError(errorMsg);
    if ("" === errorMsg)
      setIsOpenDialog(true);
  }

  const handleConfirmInitiation = async () => {
    setIsOpenDialog(false);
    if (showSuccessMessage) {
      setShowSuccessMessage(true);
    }

    let reqBodyForInitiateTrace = {};
    if (data) {
      reqBodyForInitiateTrace = {
        payment_id: data.payment_id,
        //correlation_id: data.correlation_id,
        fi_number: data.fi_number,
        updated_by: user.userId,
        comment: comment
      };
    }

    dispatch(
      actions.tracePaymentActions.initiateTrace(
        reqBodyForInitiateTrace,
        { setShowSuccessMessage, setLoading }
      )
    );

    setIsTraceInitiated(true); // Disable the input and button
  };

  return (
    <div role="main">
      {/* {showSuccessMessage && (
        <ConfirmationMessage
            message={t("erps.transactiondetails.page.confirm.button.traceIntiation")}
            setShowMessage={setShowSuccessMessage}
            inputRef={successRef}
        />
    )} */}

      {/* {showSuccessMessage && (
    <ConfirmationMessage
        message={t("erps.transactiondetails.page.confirm.button.traceIntiation")}
        setShowMessage={() => {
            // Do not reset showSuccessMessage to false after closing success message
            {showSuccessMessage && (
              <ConfirmationMessage
                  message={t("erps.transactiondetails.page.confirm.button.traceIntiation")}
                  setShowMessage={() => {
                      // Do not reset traceInitiated, just hide success message
                      setShowSuccessMessage(false);
                  }}
                  inputRef={successRef}
              />
          )}
          
        }}
        inputRef={successRef}
    />
)} */}

      {showSuccessMessage && (
        <ConfirmationMessage
          message={t("erps.transactiondetails.page.confirm.button.traceIntiation")}
          setShowMessage={() => setShowSuccessMessage(false)}
          inputRef={successRef}
        />
      )}

      <ErrorMessage 
        error={errorMessage}
        errorRef={errorRef}
        mt={2}
      />
      <ResponsiveBox sx={{ ml: 3 }}>
        <Breadcrumb {...props} fromDetailPage={true}/>
      </ResponsiveBox>

      <ERPSTransactionDetails data={data} ref={successRef} />

      {/*<ResponsiveBox sx={{ width: "60%" }}>
                <div>{comment}</div>
            </ResponsiveBox> */}

      <ResponsiveBox sx={{ ml: 3, mt: 3, display: "flex", alignItems: "center" }}>
        {isTraceInitiated ? (
          <Typography variant="label" className="transaction__enquiry__value">
            {t("erps.tracepayment.label.trace.reason")}
            <Typography variant="body2">{comment}</Typography>
          </Typography>
        ) : (
          <TextField
            label={t("erps.tracepayment.label.trace.reason")}
            fullWidth
            multiline
            rows={1}
            value={comment}
            onChange={handleCommentChange}
            required={true}
            error={!!commentError}
            helperText={commentError || `${comment.length}/300 characters`}
            inputProps={{ maxLength: 300 }}
            sx={{ width: "60%" }}
          />
        )}
      </ResponsiveBox>

      <HStack spacing={2} ml={3}>
        <ERPSBaseButton
          variant="secondary"
          className="button_with_margin48"
          label={t("erps.newuser.button.back", "Back")}
          onClick={() =>
            props.history.push("/trace-payments", {
              fromDetailPage: true,
              isTraceInitiated: isTraceInitiated
            })
          }
        />

        {!isTraceInitiated && (
          <ERPSBaseButton
            variant="primary"
            className="button_with_margin48"
            label={t("erps.transactionEnquiry.page.transactionDetails.button.traceIntiation", "Initiate Trace")}
            onClick={handleInitiateTrace}
            loading={loading}
          />
        )}
      </HStack>
      <Dialog
        open={isOpenDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogHeader
          id="alert-dialog-title"
          onClose={() => setIsOpenDialog(false)}
          className={"box-dialog-header"}
        >
          {t("erps.common.label.confirmation")}
        </DialogHeader>
        <DialogContent
          id="alert-dialog-description"
          className={"dialog-content-size"}
        >
          {t("erps.traceManagement.page.confirm.initiateTraceDetails.dialog.content")}
        </DialogContent>
        <DialogActions className={"box-dialog-buttons"}>
          <ERPSBaseButton
            variant="secondary"
            className="button_with_zeromargin"
            onClick={() => setIsOpenDialog(false)}
            label={t("erps.common.button.cancel")}
          />
          <ERPSBaseButton
            variant="primary"
            className="button_with_zeromargin"
            onClick={handleConfirmInitiation}
            label={t("erps.welcome.page.button.Ok")}
          />
        </DialogActions>
      </Dialog>

    </div>
  );
};

export default withSidebar(TraceInitationDetails);
